module.exports = __webpack_public_path__ + "static/31-img-2-43261a0539c5aee01962015f533d0d24.png";